import React from 'react';
import styled from 'styled-components';

import { DownloadProps } from '@urc-ui/components/icons/download-icon/types';
import { Icon, Link, Text } from '@amzn/storm-ui-v3';

const StyledText = styled(Text)`
  text-align: center;
`;

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.black};
`;

const DownloadIcon = (props: DownloadProps) => {
  if (!props.url) {
    return <StyledText>&#8212;</StyledText>;
  }

  return (
    <StyledDiv>
      <Link href={props.url} onClick={props.onClick}>
        <StyledIcon type='download'></StyledIcon>
      </Link>
    </StyledDiv>
  );
};

export { DownloadIcon };
